<template>
  <div class="grey lighten-5 fill-height">
    <SignIn />
    <toaster />
  </div>
</template>
<script>
import SignIn from '/src/components/pages/SignIn'
import Toaster from '@/components/commons/Toaster'

export default {
  components: { SignIn, Toaster }
}
</script>
